import tamil from '../locales/ta.json';
import hindi from '../locales/hi.json';
import malayalam from '../locales/ml.json';
import telugu from '../locales/te.json';
import kannada from '../locales/kn.json';

export const languageOptions = [
    { code: 'en', name: 'English' },
    { code: 'ta', name: 'தமிழ்' },
    { code: 'hi', name: 'हिन्दी' },
    { code: 'ml', name: 'മലയാളം' },
    { code: 'te', name: 'తెలుగు' },
    { code: 'kn', name: 'ಕನ್ನಡ' },
];
export const supportedLanguages = [...languageOptions.map(option => option.code), 'ar'];
export const localLanguageCatalogs = { ta: tamil, hi: hindi, ml: malayalam, te: telugu, kn: kannada };

export const getAppLanguage = () => {
    const routeLanguage = window.location.pathname.split('/')[1];
    if (supportedLanguages.includes(routeLanguage)) return routeLanguage;
    try {
        const saved = localStorage.getItem('langCode');
        return supportedLanguages.includes(saved) ? saved : 'en';
    } catch {
        return 'en';
    }
};

export const languagePath = (language, pathname, search = '', hash = '') => {
    const parts = pathname.split('/');
    if (supportedLanguages.includes(parts[1])) parts[1] = language;
    else parts.splice(1, 0, language);
    return parts.join('/') + search + hash;
};

const normalize = value => value.replace(/\s+/g, ' ').trim().toLowerCase();
const dictionaries = Object.fromEntries(Object.entries(localLanguageCatalogs).map(([code, catalog]) =>
    [code, new Map(Object.entries(catalog).map(([key, value]) => [normalize(key), value]))]));

// Translate presentation text only. Numbers, React elements and other values pass through.
export const translateText = (value, language = getAppLanguage()) => {
    const dictionary = dictionaries[language];
    if (!dictionary || typeof value !== 'string') return value;
    const translated = dictionary.get(normalize(value));
    if (translated) return value.match(/^\s*/)[0] + translated + value.match(/\s*$/)[0];
    const pageTitle = value.match(/^(.*?) - (.+)$/);
    if (pageTitle) return `${pageTitle[1]} - ${translateText(pageTitle[2], language)}`;
    const checkout = value.match(/^Checkout, (\d+) items in cart$/);
    const format = (key, values) => (dictionary.get(key) || value).replace(/\{(\w+)\}/g, (_, name) => values[name] ?? '');
    if (checkout) return format('__checkout', { count: checkout[1] });
    const remove = value.match(/^Remove (.+) from cart$/);
    if (remove) return format('__remove', { name: translateText(remove[1], language) });
    const quantity = value.match(/^Quantity for (.+)$/);
    if (quantity) return format('__quantity', { name: translateText(quantity[1], language) });
    const orderNumber = value.match(/^Order number (.+)$/);
    if (orderNumber) return format('__order_number', { number: orderNumber[1] });
    const required = value.match(/^(.+) is required$/);
    if (required) return format('__required', { name: translateText(required[1], language) });
    const length = value.match(/^(.+) (min|max) length should be (\d+) characters$/);
    if (length) return format('__' + length[2] + '_length', { name: translateText(length[1], language), count: length[3] });
    return value;
};
